import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';

export interface ConfirmTypeToDeleteModalData {
  header: string;
  description: string;
  confirmLabel: string;
  // The exact text the admin must type to enable the destructive action (case/space-insensitive).
  expectedValue: string;
}

@Component({
  selector: 'app-confirm-type-to-delete-modal',
  imports: [ReactiveFormsModule, ButtonComponent],
  templateUrl: './confirm-type-to-delete-modal.component.html',
  styleUrl: './confirm-type-to-delete-modal.component.scss'
})
export class ConfirmTypeToDeleteModalComponent {
  public data: ConfirmTypeToDeleteModalData = inject(MAT_DIALOG_DATA);
  public confirmControl = new FormControl('');

  constructor(private dialogRef: MatDialogRef<ConfirmTypeToDeleteModalComponent>) {}

  get canDelete(): boolean {
    return this.confirmControl.value?.trim().toLowerCase() === this.data.expectedValue.trim().toLowerCase();
  }

  confirm(): void {
    if (!this.canDelete) {
      return;
    }
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
